module.exports = __webpack_public_path__ + "img/novelfour.aee6a14e.png";